import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import OutrightOddButton from './OutrightOddButton';
import { marketDisplayName, sortOutcomesForDisplay } from '../utils';

function MarketGroup({ event, market, defaultExpanded = false }) {
  const { t } = useTranslation('translations', { useSuspense: false });
  const [expanded, setExpanded] = useState(defaultExpanded);

  if (!market?.outcomes?.length) return null;

  const sorted = sortOutcomesForDisplay(market.outcomes, event?.se?.id, market?.stringId);
  const total = sorted.length;
  const visible = expanded ? sorted : sorted.slice(0, 3);
  const hasMore = total > 3;

  const toggle = () => setExpanded((v) => !v);

  return (
    <div
      className="rounded mb-2 border-gray-300"
      style={{
        background: 'transparent',
        boxShadow: 'none',
        overflow: 'hidden'
      }}
    >
      <button
        type="button"
        onClick={toggle}
        className="btn w-100 d-flex align-items-center gap-2 py-2 px-1"
        style={{
          background: 'transparent',
          border: 'none',
          textAlign: 'left',
          color: 'var(--bs-body-color)',
          borderBottom: expanded ? '1px solid var(--bs-border-color)' : 'none'
        }}
      >
        <span className="fw-bold fs-7">
          {marketDisplayName(market, t)}
        </span>
        <span className="ms-auto" style={{ transform: expanded ? 'rotate(180deg)' : 'none', transition: 'transform 180ms ease' }}>
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M2 3l3 3 3-3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
      </button>

      <div
        className="px-1 py-2 d-grid"
        style={{ gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', columnGap: '0.75rem', rowGap: '0.75rem' }}
      >
        {visible.map((outcome) => (
          <OutrightOddButton
            key={outcome.id}
            event={event}
            market={market}
            outcome={outcome}
            name={outcome.name}
          />
        ))}
      </div>

      {!expanded && hasMore && (
        <button
          type="button"
          onClick={toggle}
          className="btn w-100 py-2 fs-8 fw-bold"
          style={{
            background: 'transparent',
            border: 'none',
            borderTop: '1px solid var(--bs-border-color)',
            color: 'var(--bs-primary)'
          }}
        >
          {t('outrights.showAll', { count: total })}
        </button>
      )}
    </div>
  );
}

export default MarketGroup;
